import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const UserList = Loadable(lazy(() => import('./UserList')));
const AddUser = Loadable(lazy(() => import('./AddUser')));
const PagePermission = Loadable(lazy(() => import('./PagePermission')));

const UserRoutes = [
	{
		path: '/User/list',
		element: <UserList />,
		auth: authRoles.admin,
	},
	{
		path: '/User/manage',
		element: <AddUser />,
		auth: authRoles.admin,
	},
	{
		path: '/Role/permission',
		element: <PagePermission />,
		auth: authRoles.admin,
	},
];

export default UserRoutes;
